import { render, staticRenderFns } from "./Parsers.vue?vue&type=template&id=220cec67"
import script from "./Parsers.vue?vue&type=script&lang=js"
export * from "./Parsers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports